export const PERSON_GET = 'personGet'
export const PERSONS_GET = 'personsGet'
export const PERSON_CREATE = 'personCreate'
export const PERSON_UPDATE = 'personUpdate'
export const PERSON_SEARCH = 'personSearch'
export const PERSON_SEARCH_NAME = 'personSearchName'